import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { useCurrency } from "@shared/selectors/globalSelectors";

interface PaymentSummaryProps {
  mode: string;
  amountDue: number;
  amountPaid?: number;
}

export const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  mode,
  amountDue,
  amountPaid = 0,
}) => {
    const currency = useCurrency();
  const { outstanding, change } = useMemo(() => {
    const diff = amountDue - amountPaid;

    return {
      outstanding: diff > 0 ? diff : 0,
      change: diff < 0 ? Math.abs(diff) : 0,
    };
  }, [amountDue, amountPaid]);
  console.log('debug mode, due, paid', mode, amountDue, amountPaid);
  return (
    <Card className="border border-blue-200 bg-blue-50">
      <CardHeader>
        <CardTitle className="text-base">Payment Summary</CardTitle>
      </CardHeader>

      <CardContent className="space-y-2 text-sm">
        <SummaryRow label="Total Due" value={`${currency} ${amountDue.toFixed(2)}`} />
        <SummaryRow label="Amount Paid" value={`${currency} ${amountPaid.toFixed(2)}`} />

        {mode === "Cash" && outstanding > 0 && (
          <SummaryRow
            label="Outstanding Balance"
            value={`${currency} ${outstanding?.toFixed(2)}`}
            highlight="text-red-600"
          />
        )}

        {mode === "Cash" && change > 0 && (
          <SummaryRow
            label="Change to Return"
            value={`${currency} ${change?.toFixed(2)}`}
            highlight="text-green-600"
          />
        )}
      </CardContent>
    </Card>
  );
};

const SummaryRow = ({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string;
  highlight?: string;
}) => (
  <div className="flex justify-between">
    <span className="text-muted-foreground">{label}</span>
    <span className={`font-semibold ${highlight ?? ""}`}>{value}</span>
  </div>
);
